<template>
  <v-card class="elevation-5">
    <v-row class="px-4">
      <slot name="searchFields"/>
      <v-col v-if="properties.submitBtn" cols="12" class="pt-1">
        <v-btn
            block
            color=      "primary"
            :disabled=  "properties.loading || properties.submitBtn.disabled"
            @click=     "properties.getData"
        >
          {{$t('field.SEARCH')}}
        </v-btn>
      </v-col>
    </v-row>
    <v-card-title class="pb-0 pt-10">
      <v-text-field
          v-if="properties.items.length > 0"
          hide-details
          outlined
          reverse
          dense
          :label=       "$t('field.FREE_SEARCH')"
          v-model=      "search"
          append-icon=  "mdi-magnify"
      />
    </v-card-title>
    <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" total-visible="20"/>
    <v-data-table
        hide-default-footer
        multi-sort
        dense
        dir=                "rtl"
        :items=             "properties.items"
        :search=            "searchTrigger"
        :headers=           "properties.headers"
        :loading=           "properties.loading"
        :sort-by=           "properties.sortBy"
        :sort-desc=         "properties.sortDir"
        :page.sync=         "page"
        :loading-text=      "$t('field.Loading')"
        :no-data-text=      "$t('field.NoData')"
        :items-per-page=    "properties.itemsPerPage"
        :no-results-text=   "$t('field.NotFound')"
        :mobile-breakpoint= "1000"
        @pagination=        "pagination"
    >
      <template v-for="field in properties.dynamicFieldsSlots" v-slot:[`item.${field}`] = '{ item }'>
        <slot :name='field' :item='item'/>
      </template>
    </v-data-table>
    <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" total-visible="20"/>
  </v-card>
</template>
<script>
  export default {
    props: { properties: Object },
    computed: {
      pageCount()     { return Math.ceil(this.filteredItemsCount / this.properties.itemsPerPage)  },
      searchTrigger() { return this.search.length < 3 ? '' : this.search                          }
    },
    data() {
      return {
        page:               0,
        search:             '',
        filteredItemsCount: 0
      }
    },
    methods: {
      pagination(pagination) {
        this.filteredItemsCount = pagination.itemsLength
      }
    }
  }
</script>
<style>
  .v-data-table-header-mobile {
    display: none;
  }
</style>
